import React from 'react';
import styled from 'styled-components';
import { CrudStyles } from '../shared/Crud';

const Overlay = styled.div`
    position: fixed;
    inset: 0;
    box-sizing: border-box;
    padding: 16px;
    overflow-y: auto;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
`;

const ModalBox = styled.div`
    box-sizing: border-box;
    background: white;
    padding: 24px;
    border-radius: 12px;
    width: 100%;
    max-width: min(400px, calc(100vw - 32px));
    max-height: min(90vh, 90dvh);
    overflow-y: auto;
    box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
`;

const Title = styled.h2`
    margin: 0 0 12px;
    font-size: 18px;
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#222'};
`;

const Message = styled.p`
    margin: 0 0 24px;
    font-size: 14px;
    line-height: 1.5;
    color: ${({ theme }) => theme?.colors?.gray?.[900] || '#444'};
`;

const Actions = styled.div`
    display: flex;
    gap: 12px;
    flex-wrap: wrap;
    justify-content: flex-end;
`;

const { Button } = CrudStyles;

export default function ConfirmRemoveItemModal({ onConfirm, onClose, isRemoving = false }) {
    return (
        <Overlay onClick={(e) => e.target === e.currentTarget && !isRemoving && onClose?.()}>
            <ModalBox onClick={(e) => e.stopPropagation()}>
                <Title>Remover item da entrega?</Title>
                <Message>
                    Esta ação não pode ser desfeita. O item será removido da entrega.
                </Message>
                <Actions>
                    <Button
                        type="button"
                        variant="outline"
                        onClick={onClose}
                        disabled={isRemoving}
                    >
                        Não, manter
                    </Button>
                    <Button
                        type="button"
                        variant="danger"
                        onClick={onConfirm}
                        disabled={isRemoving}
                    >
                        {isRemoving ? 'Removendo...' : 'Sim, remover'}
                    </Button>
                </Actions>
            </ModalBox>
        </Overlay>
    );
}
